import { TApiErrorCodes } from 'api/errors'

export interface IApiErrorCause {
  status: number
  code: string
  meta?: Record<string, unknown>
}

export class ApiError extends Error {
  public errorCode?: TApiErrorCodes
  constructor(
    error: Error,
    public cause: IApiErrorCause
  ) {
    super(error.message)
    this.name = `[API_ERROR] ${error.message}`
  }
}

export class ReduxThunkError extends Error {
  constructor(error: Error | unknown) {
    super(error instanceof Error ? error.message : 'Unknown error')
    this.name = `[REDUX_THUNK_ERROR] ${error instanceof Error ? error.message : 'Unknown error'}`
  }
}

export class ReportedIssue extends Error {
  constructor(message: string) {
    super(message)
    this.name = `[REPORTED_ISSUE] ${message}`
  }
}
